import { Component, OnInit } from '@angular/core';
import { NavigationList } from '@app-models/navigationList';
import { AuthService } from '@app-services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { getProfileURL } from '@app-utils/helper';
@Component({
  selector: 'app-dashboard-layout',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardLayoutComponent implements OnInit {
  drawerButtonOption = {
    icon: 'menu',
    onClick: () => (this.isDrawerOpen = !this.isDrawerOpen),
  };

  currentUser: any;
  profileImage: string;
  navigation: NavigationList[] = [
    /*{id: 1, text: 'Dashboard', route: '/dashboard', icon: 'home'},
    {
      id: 2,
      text: 'Camp Management',
      route: null,
      icon: 'pool',
      expanded: true,
      items: [
        { id: 21, text: 'Venues', route: '/venues', icon: null },
        { id: 22, text: 'Camp Series', route: '/camp-series', icon: null },
        { id: 23, text: 'Curriculums', route: '/curriculums', icon: null }
      ]
    },
    {
      id: 3,
      text: 'Reporting',
      route: null,
      icon: 'chart',
      expanded: true,
      items: [
        { id: 31, text: 'Events', route: '/events', icon: null },
        { id: 32, text: 'Sessions', route: '/sessions', icon: null },
        { id: 33, text: 'Swim Teams', route: '/swim-team', icon: null },
        { id: 34, text: 'Customers', route: '/customers', icon: null },
        { id: 35, text: 'Orders', route: '/orders', icon: null },
        { id: 36, text: 'Waitlists', route: '/waitlists', icon: null },
        { id: 37, text: 'Transfers', route: '/transfers', icon: null },
        { id: 38, text: 'Gear Sales', route: '/gear-sales', icon: null }
      ]
    },
    {
      id: 4,
      text: 'Emails',
      route: null,
      icon: 'email',
      expanded: true,
      items: [
        { id: 41, text: 'Email Templates', route: '/email-templates', icon: null },
        { id: 42, text: 'Scheduled Emails', route: '/scheduled', icon: null }
      ]
    }*/
  ];

  selectedMenu = [];
  selectedOpenMode = 'shrink';
  selectedPosition = 'left';
  selectedRevealMode = 'slide';
  isDrawerOpen = true;

  constructor(
    private authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.currentUser = this.authService.currentUserValue;
    console.log('Current User:', this.currentUser); 

    

    let allowed_to_manage_camps = [
      'david@fitterandfaster.com',
      'cierra@fitterandfaster.com',
      'keith@wordjuice.net',
      'michael@wordjuice.net',
      'mihamil86@gmail.com',
      'david@arluck.com',
      'dbriggs@fitterandfaster.com',
      'DAVID@ARLUCK.COM',
      'atiba@fitterandfaster.com',
      'jnelson@fitterandfaster.com'
    ];

    let disableReportingAccess = [
      'atiba@fitterandfaster.com'
    ];

    if(!disableReportingAccess.includes(this.currentUser.email.toLowerCase())) {
      this.navigation = [
      {id: 1, text: 'Dashboard', route: '/dashboard', icon: 'home'}];
    }
 
    
    if(allowed_to_manage_camps.includes(this.currentUser.email.toLowerCase()))
    {
      this.navigation.push(
      {
        id: 2,
        text: 'Camp Management',
        route: null,
        icon: 'pool',
        expanded: true,
        items: [
          { id: 21, text: 'Venues', route: '/venues', icon: null },
          { id: 22, text: 'Camp Series', route: '/camp-series', icon: null },
          { id: 23, text: 'Curriculums', route: '/curriculums', icon: null }
        ]
      });
    }

    if(!disableReportingAccess.includes(this.currentUser.email.toLowerCase())) {

        this.navigation.push({
          id: 3,
          text: 'Reporting',
          route: null,
          icon: 'chart',
          expanded: true,
          items: [
            { id: 31, text: 'Events', route: '/events', icon: null },
            { id: 32, text: 'Sessions', route: '/sessions', icon: null },
            { id: 33, text: 'Swim Teams', route: '/swim-team', icon: null },
            { id: 34, text: 'Customers', route: '/customers', icon: null },
            { id: 35, text: 'Orders', route: '/orders', icon: null },
            { id: 36, text: 'Waitlists', route: '/waitlists', icon: null },
            { id: 37, text: 'Transfers', route: '/transfers', icon: null },
            { id: 38, text: 'Gear Sales', route: '/gear-sales', icon: null }
          ]
        });


        this.navigation.push({
          id: 4,
          text: 'Emails',
          route: null,
          icon: 'email',
          expanded: true,
          items: [
            { id: 41, text: 'Email Templates', route: '/email-templates', icon: null },
            { id: 42, text: 'Scheduled Emails', route: '/scheduled', icon: null }
          ]
        });
      }


      console.log('Final navigation', this.navigation);
    this.profileImage = getProfileURL(this.currentUser.displayName);
    const routerState = '_routerState';
    const { url } = this.activatedRoute.snapshot[routerState];
    const navItem = this.navigation.find((x) => x.route === url);
    if (navItem) {
      this.selectedMenu = [navItem.id];
    }
  }

  onMenuItemClick(e): void {
    console.log('Selected items', this.selectedMenu)
    const item = e.itemData;

    if (item.items && item.items.length > 0) {
      item.expanded = !item.expanded;
    } else {
      if (item.route) {
        this.router.navigate([item.route]);
      }
    }
  }

  navigateToRoute(item: NavigationList, event: Event): void {
    event.stopPropagation();
    event.preventDefault();

    if (item.route) {
      this.selectedMenu = [item.id];
      this.router.navigateByUrl(item.route);
    }
  }

  onLogout(): void {
    this.authService.logout();
  }

  isSelected(item: NavigationList): boolean {
    return this.selectedMenu.includes(item.id);
  }
}
